import React from 'react';
import styled from 'styled-components';
import { AditionalBadges } from '../atoms/aditionalBadges';
import { HowItWorksLink } from '../atoms/howItWorksLink';
import { SellerSales } from '../atoms/sellerSales';

type DispatchMetrics = (event: string, data: { [key: string]: string }) => void;

interface SellerHighlightProps {
  range: string;
  hasBadgeCustomCare: boolean;
  hasBadgeFastDelivery: boolean;
  hasMainBadge: boolean;
  dispatchMetrics: DispatchMetrics;
}

export const SellerHighlight = ({
  range,
  hasBadgeCustomCare,
  hasBadgeFastDelivery,
  hasMainBadge,
  ...props
}: SellerHighlightProps) => {
  const hasSpacer = (hasBadgeCustomCare || hasBadgeFastDelivery) && !!range;
  return (
    <Wrapper hasMainBadge={hasMainBadge}>
      <Box>
        <AditionalBadges hasBadgeCustomCare={hasBadgeCustomCare} hasBadgeFastDelivery={hasBadgeFastDelivery} />
        {hasSpacer && <Spacer />}
        <SellerSales icon={range} />
      </Box>
      <HowItWorksLink {...props} />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ hasMainBadge: boolean }>`
  padding: ${({ hasMainBadge }) => (hasMainBadge ? '0 16px 16px' : '12px 16px 16px')};

  @media screen and (max-width: 768px) {
    padding: 16px 8px;
  }
`;

const Box = styled.div`
  @media screen and (max-width: 768px) {
    border: 1px solid #f4f4f4;
    border-radius: 8px;
    padding: 12px 10px;
  }
`;

const Spacer = styled.hr`
  border: none;
  display: block;
  width: 100%;
  height: 1px;
  background: #f4f4f4;
  margin: 10px 0 12px;

  @media screen and (max-width: 768px) {
    margin: 8px 0;
  }
`;
